// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"836":"0aab1925","946":"b01307c9"}[chunkId] + ".js";
};